import React from "react";
import * as FileSaver from "file-saver";
import * as ExcelJs from "exceljs";
import { logDownloadSchedule } from "utils/builder/IAmecLog";
import { viewerGetScreenShot } from "../../utils/builder/IScheduleLogic";
import "./DownloadInfoTableExcel.scss";
import $ from "jquery";

import UniversalButton from "components/uiComponents/UniversalButton";

import { ReactComponent as ReportIcon } from "static/icons/report-download.svg";

const DownloadInfoTableExcel = ({ header, lines, fileName, isCheckFlag }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = () => {
    var excelHeader,
      excelLines = [];
    //Get the table to find the checkbox information
    var tableBodies = document.getElementsByClassName("table-body");
    // Create workbook and sheet
    const workbook = new ExcelJs.Workbook();
    const sheet = workbook.addWorksheet("data");

    //Make sure we have all the data needed for the checkbox collumn
    if (
      tableBodies.length === 1 &&
      tableBodies[0].children != null &&
      tableBodies[0].children.length === lines.length
    ) {
      // Add Checked to header
      excelHeader = header;

      // Add column headers
      sheet.columns = excelHeader.map((columnHeader) => {
        return { header: columnHeader, key: columnHeader };
      });

      for (var i = 0; i < lines.length; i++) {
        // Get the value for the checkbox in line i
        var isChecked;
        try {
          const tableRow = tableBodies[0].children[i];
          const checkboxElement =
            tableRow.children[0].children[0].children[0].children[0];
          isChecked = checkboxElement.className.includes("--checked");
        } catch (error) {
          isChecked = false;
        }
        if(isCheckFlag && isChecked) {
          excelLines.push([...lines[i]]);
        }
        if(!isCheckFlag){
          excelLines.push([...lines[i]]);
        }
      }

      //excelLines = excelLines.map((lines) => {
      //  return ["", ...lines.slice(2), lines[1]];
      //});
    }

    // Add rows with headers and lines data
    for (var i = 0; i < excelLines.length; i++) {
      sheet.addRow(excelLines[i]);
    }

    sheet.addRow([""]);
      sheet.addRow(["Total: " + excelLines.length]);

    if (excelLines.length > 0) {
      // add count
      var cellRef = "B" + (excelLines.length + 3);
      var cellValue = {
        formula: "COUNTA(B" + 2 + ":B" + (excelLines.length + 1) + ")",
      };
      sheet.getCell(cellRef).value = cellValue;

      // add sums line
      for (var i = 2; i <= excelHeader.length; i++) {
        cellRef = letterFromNumber(i) + (excelLines.length + 3);
        cellValue = {
          formula:
            "SUM(" +
            letterFromNumber(i) +
            2 +
            ":" +
            letterFromNumber(i) +
            (excelLines.length + 1) +
            ")",
        };
        sheet.getCell(cellRef).value = cellValue;
      }
    }

    // Style excel sheet
    // Color need to be in hex8 code format
    // use this website for example to get hex8 color code https://www.schemecolor.com/
    const colorFillHeader = "FFF29B1A";
    const colorFillTotals = "FF95B3D7";
    const commonPatternFill = "solid";
    const colorBorder = "FF181818";
    const borderStyle = "thin";
    const alignmentCenter = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };

    const borderThinBlack = {
      top: { style: borderStyle, color: { argb: colorBorder } },
      right: { style: borderStyle, color: { argb: colorBorder } },
      bottom: { style: borderStyle, color: { argb: colorBorder } },
      left: { style: borderStyle, color: { argb: colorBorder } },
    };

    const headerRowIndex = 1;
    const totalsRowIndex = sheet.rowCount;

    for (var rowIndex = 1; rowIndex <= sheet.rowCount; rowIndex++) {
      for (
        var columnIndex = 1;
        columnIndex <= sheet.columnCount;
        columnIndex++
      ) {
        const cell = sheet.getCell(rowIndex, columnIndex);
        cell.alignment = alignmentCenter;
        cell.border = borderThinBlack;

        if (rowIndex === headerRowIndex) {
          cell.font = {
            bold: true,
            size: 14,
          };

          cell.fill = {
            type: "pattern",
            pattern: commonPatternFill,
            fgColor: { argb: colorFillHeader },
          };
        } else if (rowIndex === totalsRowIndex) {
          cell.fill = {
            type: "pattern",
            pattern: commonPatternFill,
            fgColor: { argb: colorFillTotals },
          };
        } else {
          // Other rows except the header
          cell.font = {
            size: 12,
          };
        }
      }
    }

    //Autosize column width
    autosizeColumnsWidth(sheet);

    // Conditional formatting dependent on value in first column
    addConditionalFormatting(sheet);

    // Get screenshot url and write it to Excel file
    // then save Excel file
    // const classNameView = ".editor-section__body";
    // var imageWidth = $(classNameView).width();
    // var imageHeight = $(classNameView).height();

    const excelWidthKoef = 7;
    const excelMaxWidth = 1850;
    let imageWidth = 0;
    sheet.columns.forEach((c) => (imageWidth += c.width));
    imageWidth *= excelWidthKoef;
    if (imageWidth > excelMaxWidth)
          imageWidth = excelMaxWidth;

    let imageHeight = imageWidth / 4;

    // round width and height because it must be divided by 4 without remainder for Forge API
    const roundImageWidth = imageWidth - (imageWidth % 4);
    const roundImageHeight = imageHeight - (imageHeight % 4);

    // Get model screenshot and write data to Excel file
    viewerGetScreenShot(roundImageWidth, roundImageHeight, async (blobUrl) => {
      if (blobUrl) {
        // Convert image blobUrl to blob
        let blob = await fetch(blobUrl).then((r) => r.blob());

        var reader = new FileReader();
        reader.readAsDataURL(blob);

        reader.onloadend = function () {
          var imageBase64String = reader.result;
          // create image from base64 string
          const image = workbook.addImage({
            base64: imageBase64String,
            extension: "jpeg",
          });

          // add image to excel sheet file
          sheet.addImage(image, {
            tl: { col: 0, row: excelLines.length + 4 },
            ext: { width: roundImageWidth, height: roundImageHeight },
          });

          // save excel file
          workbook.xlsx.writeBuffer().then(function (buffer) {
            const blob = new Blob([buffer], { type: fileType });
            FileSaver.saveAs(blob, fileName + fileExtension);
          });

          //logging the download excel event
          logDownloadSchedule();
        };
      }
    });
  };

  return (
    <UniversalButton
      label={isCheckFlag ? "Report for selection" : "Download report"}
      leftIcon={<ReportIcon className="download-excel__button_icon" />}
      size="md"
      isRounded="sm"
      labelColor="white"
      labelHoverColor="white"
      backgroundColor="orange"
      backgroundHoverColor="orange-light"
      onClick={exportToCSV}
    />
  );
};

function addConditionalFormatting(sheet) {
  const cellRefStart = "A2";
  const cellRefEnd = sheet.getCell(
    sheet.rowCount - 1,
    sheet.columnCount
  ).address;

  const ref = cellRefStart + ":" + cellRefEnd;
  sheet.addConditionalFormatting({
    ref: ref,
    rules: [
      {
        type: "expression",
        formulae: ["=EXACT($A2, TRUE)"],
        style: {
          fill: {
            type: "pattern",
            pattern: "solid",
            bgColor: { argb: "FFEBF1DE" },
          },
        },
      },
    ],
  });
}

function autosizeColumnsWidth(sheet) {
  sheet.columns.forEach((column) => {
    const lengths = column.values.map((value) => value.toString().length);
    column.width = Math.max(
      Math.max(...lengths.filter((value) => typeof value === "number")) + 2,
      column.header.length + 6
    );
    if(column.width > 100) {
      column.width = 100;
    }
  });
}

function letterFromNumber(number) {
  if (number <= 26) {
    return String.fromCharCode(96 + number).toUpperCase();
  } else {
    return (
      letterFromNumber(Math.floor(number / 26)) + letterFromNumber(number % 26)
    );
  }
}

export default DownloadInfoTableExcel;
